import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/LandingPage.css";
import { useAuthStore } from "../store/useAuthStore";

const LandingPage = () => {
  const navigate = useNavigate();
  const [showCard, setShowCard] = useState(false);
  const { initializeAuth, role, isAuthenticated } = useAuthStore();

  useEffect(() => {
    initializeAuth(); // 🔹 load token + user from localStorage
    const timer = setTimeout(() => setShowCard(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  const handleNetZeroClick = () => {
    if (!isAuthenticated) {
      alert("Please login again!");
      return;
    }

    if (role === "Admin") {
      navigate("/dashboard");
    } else if (role === "User") {
      navigate("/project-details");
    } else {
      alert("Role not found. Please login again.");
    }
  };

  return (
    <div className="landing-container">
      {showCard && (
        <div className="netzero-card">
          <h2 className="netzero-title">Verified Net Zero Hotel Assessment</h2>
          <p className="netzero-subtext">
            Start your journey today and get to know how close you are to become a Verified Net Zero hotel!
          </p>
          <button className="netzero-btn" onClick={handleNetZeroClick}>
            Start
          </button>
        </div>
      )}
    </div>
  );
};

export default LandingPage;